import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useRef, useEffect } from 'react';

import MapProvider    from 'providers/MapProvider';
import DataProvider   from 'providers/DataProvider';
import ThemeProvider  from 'providers/ThemeProvider';
import NotificationPermissionProvider from 'providers/NotificationPermissionProvider';

import WelcomeMessage from 'components/WelcomeMessage';
import NavBar         from 'components/NavBar';
import MobileNavBar   from 'components/MobileNavBar';
import BottomNavBar   from 'components/BottomNavBar';

import HomePage             from 'pages/Home';
import LogIn                from 'pages/Login';
import SignUp               from 'pages/Signup';
import LogOut               from 'pages/Logout';
import ForgotPasswordPage   from 'pages/ForgotPassword';
import ResetPasswordPage    from 'pages/ResetPassword';
import CreateActivity       from 'pages/CreateActivity';
import CreateGroup          from 'pages/CreateGroup';
import ActivityPage         from 'pages/Activity';
import ActivityChat         from 'pages/ActivityChat';
import GroupPage            from 'pages/Group';
import UserProfile          from 'pages/UserProfile';
import NotificationsPage    from 'pages/Notifications';
import Team                 from 'pages/Team';
import BugReportPage        from 'pages/BugReport';
import BugReportDevViewPage from 'pages/BugReportDevView';

import 'styles/styles.css';
import 'styles/Content.css';


function Content() {

  const contentRef = useRef(null);

  useEffect(() => {
    if (!contentRef.current) return;

    const setContentHeight = () => {
      const height = window.visualViewport?.height || window.innerHeight;
      contentRef.current.style.height = `${height}px`;
      window.scrollTo(0, 0);
    };

    setContentHeight();

    const viewport = window.visualViewport || window;
    viewport.addEventListener('resize', setContentHeight);

    return () => {
      viewport.removeEventListener('resize', setContentHeight);
    };
  }, []);

  return (
    <ThemeProvider>
    <DataProvider>
    <NotificationPermissionProvider>
    <div className="content" ref={contentRef}>
      <div id="background-image"/>
      <WelcomeMessage/>
      <Router>

        <NavBar/>
        <MobileNavBar/>
        
        <div className="content-body">
          <MapProvider>
            <Routes>
                <Route path="/"                           element={<HomePage/>} />
                <Route path="/login"                      element={<LogIn/> } />
                <Route path="/signup"                     element={<SignUp/>} />
                <Route path="/logout"                     element={<LogOut/> } />
                <Route path="/forgot-password"            element={<ForgotPasswordPage/>} />
                <Route path="/reset-password/:resetToken" element={<ResetPasswordPage/>} />
                <Route path="/profile"                    element={<UserProfile/> } />
                <Route path="/create-activity"            element={<CreateActivity/> } />
                <Route path="/create-group"               element={<CreateGroup/> } />
                <Route path="/activity/:activityId"       element={<ActivityPage/> } />
                <Route path="/activity/:activityId/chat"  element={<ActivityChat/> } />
                <Route path="/group/:groupId"             element={<GroupPage/>} />
                <Route path="/u/:username"                element={<UserProfile/>} />
                <Route path="/t/:activityShortId"         element={<ActivityPage/>} />
                <Route path="/tc/:activityShortId"        element={<ActivityChat/>} />
                <Route path="/g/:groupShortId"            element={<GroupPage/>} />
                <Route path="/notifications"              element={<NotificationsPage/>} />
                <Route path="/team"                       element={<Team/>} />
                <Route path="/bug"                        element={<BugReportPage/>} />
                <Route path="/bug-reports"                element={<BugReportDevViewPage/>} />
            </Routes>
          </MapProvider>
        </div>

        <BottomNavBar/>

      </Router>
    </div>
    </NotificationPermissionProvider>
    </DataProvider>
    </ThemeProvider>
  )
}

export default Content